import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$loja_segmentos = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      modalEvento: {
        show: false,
        text: "",
      },
      segmentos: [],
      filtros: [],
      filter: {
        ativo: "",
        descricao: "",
        dataInicio: "",
        dataFim: "",
      },
      // ativo: '',
      segmentoAddOrEdit: "new",
      cadastro: {
        loading: false,
        loading_segmentos: false,
        idsegmento: "",
        descricao: "",
        ativo: "",
        error: {
          descricao: [],
          ativo: [],
        },
      },
      text: "",
      funcao: "",
      idsegmento: "",
    };
  },
  methods: {
    getSegmentos() {
      this.loading_segmentos = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_SEGMENTOS,
          JSON.stringify({ todos_status: true })
        )
        .then(response => {
          // const arrayOfObj = Object.entries(response).map((e) => e[1] );
          if (response) {
            this.segmentos = response;
            this.loading_segmentos = false;
            this.$axios.setLocal("lojas_segmentos", response);
          }
        });
    },
    deletarSegmentos(idsegmento) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_SEGMENTO + idsegmento)
        .then(() => {
          this.getSegmentos();
        });
    },
    alterarSegmento() {
      this.cadastro.loading = true;
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_SEGMENTO + this.cadastro.idsegmento, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditSegmento", true);
            document.getElementsByClassName(
              "modal-body-segmento-add"
            )[0].style.display = "none";
            this.cadastro.descricao = "";
            this.cadastro.ativo = "";
            setTimeout(() => {
              this.getSegmentos();
            }, 500);
            this.cadastro.loading = false;
          }
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },
    async cadastrarSegmento() {
      this.cadastro.loading = true;
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_SEGMENTO, dados)
        .then(response => {
          if (response) {
            this.cadastro.descricao = "";
            this.cadastro.ativo = "";
            document.getElementsByClassName(
              "modal-body-segmento-add"
            )[0].style.display = "none";
            setTimeout(() => {
              this.getSegmentos();
            }, 500);
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },
    // ---- FUNÇÃO QUE ABRE MODAL PARA CONFIRMAR REMOÇÃO DOS SEGMENTOS ---- //
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.idsegmento = id;
    },
    funcaoRemover() {
      this.deletarSegmentos(this.idsegmento);
    },
    filtroSegmentos() {
      this.filtros = [];
      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (
        (this.filter.ativo != "" && this.filter.ativo != null) ||
        this.filter.ativo == 0
      ) {
        this.filtros.push({
          campo: "ativo",
          tipo: "int",
          valor: this.filter.ativo,
        });
      }
      // else if(this.filter.dataInicio != '') {
      //     this.filtros.push({
      //         campo: 'ins_dthr',
      //         tipo: 'date',
      //         orientacao: 'maior',
      //         valor: this.filter.dataInicio  + " 00:00"
      //     })
      // }
      // else if(this.filter.dataFim != '') {
      //     this.filtros.push({
      //         campo: 'ins_dthr',
      //         tipo: 'date',
      //         orientacao: 'menor',
      //         valor: this.filter.dataFim + " 23:59"
      //     })
      // }

      let filtered = this.filtros;
      this.cadastro.loading_segmentos = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_SEGMENTOS,
          JSON.stringify({ todos_status: true, filtros: filtered })
        )
        .then(response => {
          this.segmentos = response;
          this.cadastro.loading_segmentos = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    async validarCadastro() {
      if (this.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição do segmento!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao = "Preencha a descrição do segmento!";
        return;
      }

      if (this.cadastro.ativo == null) {
        this.$config.alert(
          "Selecione o status!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ativo = "Selecione o status!";
        return;
      }

      if (this.segmentoAddOrEdit == "edit") {
        this.alterarSegmento();
      } else {
        this.cadastrarSegmento();
      }
    },

    limpaFormularioDeSegmentos() {
      this.cadastro.descricao = "";
      this.cadastro.ativo = "";
      this.cadastro.error.descricao = "";
      this.cadastro.error.ativo = "";
    },

    limpaFiltros() {
      this.filter.descricao = "";
      this.filter.ativo = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.filtros = [];
    },
  },
});
